import { Messages } from '../../../../codegen/Localize';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserEditGroupMembership } from '../../../actions/spaces/SiteUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SiteUserEditGroupMembershipAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserEditGroupMembership,
  translateName: Messages.groupMembership_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditGroupMembership(targetItems)
};
